import { GroundControlPointState, LoadingState } from '../store.states';
import { GroundControlPoint } from '../../models/geoasset.model';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  createGcpAssets,
  creatingGcpAssetsError,
  creatingGcpAssetsSuccess,
  deleteGcp,
  deleteGcpError,
  deleteGcpSuccess,
  editGcp,
  editGcpError,
  editGcpSuccess,
  loadingGcpAssets,
  loadingGcpAssetsError,
  loadingGcpAssetsSuccess,
} from './gcp.actions';

export const groundControlPointsAdapter =
  createEntityAdapter<GroundControlPoint>({
    selectId: (gcp) => gcp.id,
    sortComparer: false,
  });

export const initialState: GroundControlPointState = {
  groundControlPoints: groundControlPointsAdapter.getInitialState(),
  loadingState: LoadingState.FUTURE,
  updateState: LoadingState.FUTURE,
  error: null,
  completed: false,
};

export const groundControlPointReducer = createReducer(
  initialState,
  on(loadingGcpAssets, (state) => ({
    ...state,
    loadingState: LoadingState.PENDING,
    completed: false,
  })),

  on(loadingGcpAssetsSuccess, (state, { groundControlPoints }) => ({
    ...state,
    loadingState: LoadingState.SUCCESS,
    groundControlPoints: groundControlPointsAdapter.setAll(
      groundControlPoints,
      state.groundControlPoints,
    ),
    completed: true,
  })),

  on(loadingGcpAssetsError, (state, { error }) => ({
    ...state,
    loadingState: LoadingState.ERROR,
    error: error,
    completed: false,
  })),

  on(createGcpAssets, (state) => ({
    ...state,
    loading: true,
    updateState: LoadingState.PENDING,
  })),

  on(creatingGcpAssetsSuccess, (state, { groundControlPoints }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.SUCCESS,
    groundControlPoints: groundControlPointsAdapter.addMany(
      groundControlPoints,
      state.groundControlPoints,
    ),
    error: null,
  })),

  on(creatingGcpAssetsError, (state, { error }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.ERROR,
    error,
  })),

  on(deleteGcp, (state) => ({
    ...state,
    updateState: LoadingState.PENDING,
  })),

  on(deleteGcpSuccess, (state, { gcpId }) => ({
    ...state,
    updateState: LoadingState.SUCCESS,
    groundControlPoints: groundControlPointsAdapter.removeOne(
      gcpId,
      state.groundControlPoints,
    ),
  })),

  on(deleteGcpError, (state, { error }) => ({
    ...state,
    updateState: LoadingState.ERROR,
    error: error,
  })),

  on(editGcp, (state) => ({
    ...state,
    loading: true,
    updateState: LoadingState.PENDING,
  })),

  on(editGcpSuccess, (state, { groundControlPoint }) => {
    console.log('Reducer handling editGcpSuccess, updating state');
    return {
      ...state,
      loading: false,
      updateState: LoadingState.SUCCESS,
      loadingState: LoadingState.SUCCESS,
      groundControlPoints: groundControlPointsAdapter.upsertOne(
        groundControlPoint,
        state.groundControlPoints,
      ),
      error: null,
    };
  }),

  on(editGcpError, (state, { error }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.ERROR,
    error: error,
  })),
);
